module.exports = __webpack_public_path__ + "static/media/ic-log-out.dc950b21.svg";